export default __webpack_public_path__ + "static/media/ventrilla-res2.313ffc4c.jpg";